import { ArticulosEcommerce } from '../interfaces/articulos-ecommerce.interface';
import { OfertasEcommerce } from '../interfaces/ofertas-ecommerce.interface';
import { TagsEcommerce } from '../interfaces/tags-eccomerce.interface';
import { PromocionesEccomerce } from './promociones-class';

/**
 * Promocion tipo M ("Combo"): varios articulos (items[]), cada uno con su
 * cantidad1 (unidades de ese articulo dentro del combo; cantidad2 no se usa
 * en este tipo). El precio final del combo es promocionesweb.monto (ya
 * disponible como this.monto en la clase base). El descuento es la
 * diferencia entre la suma de item.precioReal*item.cantidad1 de todos los
 * items y el monto fijo del combo.
 */
export class ComboPromo extends PromocionesEccomerce {

  setTag(tag: TagsEcommerce) {
    throw new Error('Method not implemented.');
  }

  getTag(): TagsEcommerce[] {
    throw new Error('Method not implemented.');
  }

  getMarcaReal() {
    return '';
  }

  /**
   * Se deriva de la cantidad del primer artículo del combo en el carrito
   * (no de this.counter) para que quede correcta aunque el carrito se haya
   * cargado desde el backend en vez de vía agregarCantidad() (ej. al
   * recargar la página).
   */
  getCantidad() {
    const articulo = this.articuloenPromo();
    const cantidad1 = this.cantidadenPromo();
    if (!articulo || !cantidad1) {
      return this.counter;
    }
    return Math.floor(articulo.getCantidad() / cantidad1);
  }

  getCantidadMayorista() {
    return 0;
  }

  getRemplazos() {
    throw new Error('Method not implemented.');
  }

  isdeOferta(): boolean {
    return false;
  }

  setdeOferta(ofertas: OfertasEcommerce) {
    throw new Error('Method not implemented.');
  }

  getPromosActivas(): string[] {
    return [];
  }

  getDescripcionAdicional() {
    return ' ';
  }

  getCantidadMaxima() {
    return 0;
  }

  getPrecioMayorista() {
    return 0;
  }

  getPrecioOferta(): number {
    return 0;
  }

  getPrecioNormal() {
    return 0;
  }

  getPresentacion() {
    return '';
  }

  setModificacionPrecio(arg0: number) {
    throw new Error('Method not implemented.');
  }

  setPromo(k: PromocionesEccomerce) {
    throw new Error('Method not implemented.');
  }

  setRemplazo(numero: number) {
    throw new Error('Method not implemented.');
  }

  getRemplazo() {
    throw new Error('Method not implemented.');
  }

  getPrecioPartido(): number {
    throw new Error('Method not implemented.');
  }

  getOtrosPrecios(): string {
    throw new Error('Method not implemented.');
  }

  getFraccion() {
    return 0;
  }

  getImgDownload(): boolean {
    return this.descargo;
  }

  setImgDownload(valor: boolean) {
    this.descargo = valor;
  }

  setMyBlob(body: Blob) {
    this.myblob = body;
  }

  getMyBlob(): Blob {
    return this.myblob;
  }

  operacionesExtras() {
    // console.log('se ejecuto ComboPromo');
  }

  /**
   * Suma de precioReal*cantidad1 de todos los renglones del combo, al valor
   * de lista (sin el descuento del combo aplicado).
   */
  getSumaArticulos(): number {
    return this.getItemsData().reduce(
      (acumulado, item) => acumulado + item.precioReal * item.cantidad1,
      0
    );
  }

  articuloenPromo(): ArticulosEcommerce | null {
    return this.getArticulosItems()[0] || null;
  }

  cantidadenPromo(): number {
    const item = this.getItemsData()[0];
    return item ? item.cantidad1 : 1;
  }

  getDescontadoTotal(): number {
    return this.getDescontado() * this.getCantidad();
  }

  getDescontado(): number {
    return Math.max(this.getSumaArticulos() - this.monto, 0);
  }

  getPrecioCalculado(): number {
    return this.monto;
  }

  preconPromo(precio: number, cantidad: number, modificacionActual: number) {
    return this.monto;
  }

  getPrecioAmostrar() {
    return this.getPrecioCalculado();
  }

  getPrecio() {
    return this.monto;
  }

  getPrecioSinImp() {
    return this.monto;
  }

  agregarCantidad(numero: number) {
    this.counter = (this.counter || 0) + numero;
    const items = this.getItemsData();
    this.getArticulosItems().forEach((articulo, indice) => {
      const item = items[indice];
      articulo.agregarCantidad(numero * (item ? item.cantidad1 : 1));
      articulo.operacionesExtras();
    });
  }

  setCantidad(arg0: number) {
    this.counter = arg0;
  }

  hacerCalculos() {
    return this.getSumaArticulos() - this.monto;
  }

  aplicarPromocion(precio: number) {
    return this.monto;
  }

  deOferta: OfertasEcommerce;
  isdeoferta: boolean;
  isdePromo: boolean;
  misPromo: PromocionesEccomerce[];

  private myblob: Blob;
}
